import clsx from 'clsx';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { useScrollToError } from '../hooks/useScrollToError.ts';
import { errorClasses, getContainerClasses } from '../utils/inputStyles';
import FieldValidationMessage from './FieldValidationMessage.tsx';

console.log('testing RadioGroup.tsx');

interface DataSourceItem {
  key: string;
  value: string;
}

interface IProps {
  label: string;
  name: string;
  disabled?: boolean;
  options: DataSourceItem[];
  value: string;
  updateFieldValue: (value: string) => void;
  triggerFieldChange: (value: string) => void;
  validatemessage?: string;
}

function RadioGroup(props: IProps) {
  const [selectedValue, setSelectedValue] = useState<string>(props.value);
  const isDisabled = !!props.disabled;
  const rootRef = useScrollToError(props.validatemessage, [props.value, props.updateFieldValue]);
  const handleSelect = (key: string) => {
    if (isDisabled) return;

    setSelectedValue(key);
    props.updateFieldValue(key);
    props.triggerFieldChange(key);
  };

  const containerClasses = getContainerClasses({});

  return (
    <div ref={rootRef} className={containerClasses}>
      <label className="!text-base">{props.label}</label>
      <div className="flex flex-row rounded-l-lg rounded-r-lg">
        {props.options.map((option, index) => (
          <div
            key={option.key}
            className={twMerge(
              clsx(
                `flex-1 px-4 py-3 text-center border-t border-b border-interactive-outline-default bg-interactive-surface-default cursor-pointer transition-all duration-200 text-sm text-content-primary`,
                errorClasses,
                {
                  'rounded-l-lg border-l border-r': index === 0,
                  'rounded-r-lg border-r': index === props.options.length - 1,
                  'bg-action-default border-action-default hover:bg-action-hover hover:border-action-hover !text-white font-medium':
                    selectedValue === option.key && !isDisabled,
                  'opacity-50 cursor-not-allowed hover:bg-interactive-surface-default hover:border-interactive-outline-default':
                    isDisabled,
                }
              )
            )}
            onClick={() => handleSelect(option.key)}
            data-error={!!props.validatemessage}
          >
            <input
              type="radio"
              className="hidden"
              id={`${props.name}-${option.key}`}
              name={props.name}
              disabled={isDisabled}
              value={option.key}
              checked={selectedValue === option.key}
              onChange={() => handleSelect(option.key)}
            />
            {option.value}
          </div>
        ))}
      </div>
      <FieldValidationMessage message={props.validatemessage} />
    </div>
  );
}

export default RadioGroup;
